<mat-list>
	<button
		*ngIf="this.isShowIcon"
		mat-menu-item
		(click)="this.userMenuClick('dashboard')"
		id="headerDashboard"
		matTooltip="{{ this.isShowText ? '' : dashboardTooltip }}"
		matTooltipPosition="right"
	>
		<img
			class="icon-position"
			[src]="
				activeItem === 'dashboard'
					? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/dashboardActiveNew/public'
					: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/dashboardNew/public'
			"
		/>
		<span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
		<span 
		    i18n="@@button_dashboard" 
			*ngIf="this.isShowText" 
			class="mat-typography"
			[ngStyle]="{
				color: activeItem === 'dashboard' ? '#32BF55' : '#000000'
			}"
		>Dashboard</span>
	</button>

	<button
		*ngIf="this.isShowIcon"
		mat-menu-item
		(click)="this.userMenuClick('myFundraisers')"
		id="headerMyFundraisers"
		matTooltip="{{ this.isShowText ? '' : fundraisersTooltip }}"
		matTooltipPosition="right"
	>
		<img
			class="icon-position"
			[src]="
				activeItem === 'myFundraisers'
					? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/fundraisersActiveNew/public'
					: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/fundraisersNew/public'
			"
		/>
		<span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
		<span 
		    i18n="@@header_userMenu_button_myFundraisers" 
			*ngIf="this.isShowText"
			[ngStyle]="{
				color: activeItem === 'myFundraisers' ? '#32BF55' : '#000000'
			}"
			class="mat-typography"
		>My Fundraisers</span>
	</button>

	<div *ngIf="parentFundraiserCount > 0">
		<button
			*ngIf="this.isShowIcon"
			mat-menu-item
			(click)="this.userMenuClick('donations')"
			matTooltip="{{ this.isShowText ? '' : donationsTooltip }}"
			matTooltipPosition="right"
		>
			<img
				class="icon-position"
				[src]="
					activeItem === 'donations'
						? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/donationsActiveNew/public'
						: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/donationsNew/public'
				"
			/>
			<span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
			<span 
				i18n="@@donations_zero_donation_heading" 
				*ngIf="this.isShowText"
				class="mat-typography"
				[ngStyle]="{
					color: activeItem === 'donations' ? '#32BF55' : '#000000'
				}"
			>Donations</span
			>
		</button>
	</div>

	<div *ngIf="parentFundraiserCount > 0">
		<button
			mat-menu-item
			(click)="this.userMenuClick('balance')"
			*ngIf="this.isReceiver && this.isShowIcon"
			id="headerBalance"
			matTooltip="{{ this.isShowText ? '' : balanceTooltip }}"
			matTooltipPosition="right"
		>
			<img
				class="icon-position"
				[src]="
					activeItem === 'balance'
						? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/balanceActiveNew/public'
						: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/balanceNew/public'
				"
			/>
			<span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
			<span 
			    i18n="@@header_userMenu_button_balance" 
				*ngIf="this.isShowText"
				[ngStyle]="{
					color: activeItem === 'balance' ? '#32BF55' : '#000000'
				}"
				class="mat-typography"
			>Balance</span>
		</button>
	</div>

	<div *ngIf="parentFundraiserCount > 0">
		<button
			mat-menu-item
			(click)="this.userMenuClick('payoutSettings')"
			*ngIf="this.isReceiver && this.isShowIcon"
			id="headerPayoutSettings"
			matTooltip="{{ this.isShowText ? '' : payoutsettingsTooltip }}"
			matTooltipPosition="right"
		>
			<img
				class="icon-position"
				[src]="
					activeItem === 'payoutSettings'
						? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/payoutSettingsActiveNew/public'
						: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/payoutSettingsNew/public'
				"
			/>
			<span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
			<span 
			    i18n="@@profile_payoutSettings" 
				*ngIf="this.isShowText"
				[ngStyle]="{
					color: activeItem === 'payoutSettings' ? '#32BF55' : '#000000'
				}"
				class="mat-typography"
			>Payout Settings</span>
		</button>
	</div>

	<button
		mat-menu-item
		(click)="this.userMenuClick('emailSettings')"
		*ngIf="this.isReceiver && this.isShowIcon"
		id="headerEmailSettings"
		matTooltip="{{ this.isShowText ? '' : emailsettingsTooltip }}"
		matTooltipPosition="right"
	>
		<img
			class="icon-position"
			[src]="
				activeItem === 'emailSettings'
					? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/emailSettingsActiveNew/public'
					: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/emailSettingsNew/public'
			"
		/>
		<span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
		<span 
		    i18n="@@profile_emailSettings_label" 
			*ngIf="this.isShowText"
			[ngStyle]="{
				color: activeItem === 'emailSettings' ? '#32BF55' : '#000000'
			}"
			class="mat-typography"
		>Email Settings</span>
	</button>

	<div *ngIf="parentFundraiserCount > 0">
		<button
			*ngIf="this.isShowIcon"
			mat-menu-item
			class="customBranding"
			(click)="this.userMenuClick('customiseFundraisers')"
			id="headerCustomBranding"
			matTooltip="{{ this.isShowText ? '' : customisefundraisersTooltip }}"
			matTooltipPosition="right"
		>
			<img
				class="icon-position"
				[src]="
					activeItem === 'customiseFundraisers'
						? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/fundraiserBrandingActiveNew/public'
						: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/fundraiserBrandingNew/public'
				"
			/>
			<span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
			<span
				i18n="@@header_userMenu_button_customiseFundraisers"
				*ngIf="this.isShowText"
				class="mat-typography"
				[ngStyle]="{
					color: activeItem === 'customiseFundraisers' ? '#32BF55' : '#000000'
				}"
			>Customise Fundraisers</span>
		</button>
	</div>

	<div *ngIf="parentFundraiserCount > 0">
		<button
			*ngIf="this.isShowIcon"
			mat-menu-item
			(click)="this.userMenuClick('customiseEmails')"
			id="headerCustomiseEmails"
			matTooltip="{{ this.isShowText ? '' : customiseemailsTooltip }}"
			matTooltipPosition="right"
		>
			<img
				class="icon-position"
				[src]="
					activeItem === 'customiseEmails'
						? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/emailBrandingActiveNew/public'
						: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/emailBrandingNew/public'
				"
			/>
			<span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
			<span
				i18n="@@header_userMenu_button_customiseEmails"
				*ngIf="this.isShowText"
				class="mat-typography"
				[ngStyle]="{
					color: activeItem === 'customiseEmails' ? '#32BF55' : '#000000'
				}"
			>Customise Emails</span>
		</button>
	</div>

	<div *ngIf="parentFundraiserCount > 0">
		<button
			*ngIf="this.isShowIcon"
			mat-menu-item
			(click)="this.userMenuClick('customiseReceipts')"
			id="headerReceipt"
			matTooltip="{{ this.isShowText ? '' : customisereceiptsTooltip }}"
			matTooltipPosition="right"
		>
			<img
				class="icon-position"
				[src]="
					activeItem === 'customiseReceipts'
						? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/receiptBrandingActiveNew/public'
						: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/receiptBrandingNew/public'
				"
			/>
			<span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
			<span
				i18n="@@header_userMenu_button_customiseReceipts"
				*ngIf="this.isShowText"
				class="mat-typography"
				[ngStyle]="{
					color: activeItem === 'customiseReceipts' ? '#32BF55' : '#000000'
				}"
			>Customise Receipts</span>
		</button>
	</div>
	<div *ngIf="parentFundraiserCount > 0">
		<button
			mat-menu-item
			(click)="this.userMenuClick('qrCode')"
			*ngIf="this.isReceiver && this.isShowIcon"
			id="qrCodeSettings"
			matTooltip="{{ this.isShowText ? '' : payoutsettingsTooltip }}"
			matTooltipPosition="right"
		>
			<img
				class="icon-position"
				[src]="
					activeItem === 'qrCode'
						? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/qrNavActive/public'
						: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/qrNavigation/public'
				"
			/>
			<span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
			<span 
			    i18n="@@customize_qr" 
				*ngIf="this.isShowText"
				class="mat-typography"
				[ngStyle]="{
					color: activeItem === 'qrCode' ? '#32BF55' : '#000000'
				}"
			>Customise QR Code</span>
		</button>
	</div>
	<button
		*ngIf="this.isShowIcon && this.showWidgetIcon"
		mat-menu-item
		(click)="this.userMenuClick('widget')"
		id="headerWidgets"
		matTooltip="{{ this.isShowText ? '' : widgetTooltip }}"
		matTooltipPosition="right"
	>
		<img
			class="icon-position"
			[src]="
				activeItem === 'widget'
					? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/widgetsActiveNew/public'
					: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/widgetsNew/public'
			"
		/><span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
		<span 
		    i18n="@@header_userMenu_button_widget" 
			*ngIf="this.isShowText && this.showWidgetText"
			[ngStyle]="{
				color: activeItem === 'widget' ? '#32BF55' : '#000000'
			}"
			class="mat-typography"
		>Widgets</span>
	</button>

	<button
		*ngIf="this.isShowIcon"
		mat-menu-item
		(click)="this.userMenuClick('zapier')"
		id="headerApiKey"
		matTooltip="{{ this.isShowText ? '' : apikeyTooltip }}"
		matTooltipPosition="right"
	>
		<img
			class="icon-position"
			[src]="
				activeItem === 'zapier'
					? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/integrateZapierActiveNew/public'
					: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/integrateZapierNew/public'
			"
		/>
		<span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
		<span 
		    i18n="@@header_userMenu_button_Zapier" 
			*ngIf="this.isShowText"
			class="mat-typography"
			[ngStyle]="{
				color: activeItem === 'zapier' ? '#32BF55' : '#000000'
			}"
			>Integrate Zapier
		</span>
	</button>

	<button
		*ngIf="this.isShowIcon"
		mat-menu-item
		(click)="this.userMenuClick('apiKey')"
		id="wordPressApiKey"
		matTooltip="{{ this.isShowText ? '' : apikeyTooltip }}"
		matTooltipPosition="right"
	>
		<img
			class="icon-position"
			[src]="
				activeItem === 'apiKey'
					? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/apiKeyActiveNew/public'
					: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/apiKeyNew/public'
			"
		/><span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
		<span 
		    i18n="@@header_userMenu_button_apiKey" 
			*ngIf="this.isShowText"
			class="mat-typography"
			[ngStyle]="{
				color: activeItem === 'apiKey' ? '#32BF55' : '#000000'
			}"
		>API-Key</span>
	</button>

	<div *ngIf="parentFundraiserCount > 0">
		<button
			*ngIf="this.isShowIcon"
			mat-menu-item
			(click)="this.userMenuClick('custom-domain')"
			id="headerCustomDomain"
			matTooltip="{{ this.isShowText ? '' : apikeyTooltip }}"
			matTooltipPosition="right"
		>
			<img
				class="icon-position"
				[src]="
					activeItem === 'custom-domain'
						? 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/customDomainNewActive/public'
						: 'https://imagedelivery.net/_0vgnXOEIHPwLg2E52a7gg/shared/customDomainNew/public'
				"
			/><span *ngIf="this.isShowText">&nbsp;&nbsp;&nbsp;</span>
			<span 
			    i18n="@@header_userMenu_button_customDomain" 
				*ngIf="this.isShowText"
				class="mat-typography"
				[ngStyle]="{
					color: activeItem === 'custom-domain' ? '#32BF55' : '#000000'
				}"
				>Custom Domain
			</span>
		</button>
	</div>
</mat-list>
